import store from '@/store';
import router from '@/router';
import { useGnbMenu } from '@/composables/useGnbMenu';
import { datadogRum } from '@datadog/browser-rum';

export default function useSessionHanlder() {
  const { getMenu } = useGnbMenu();
  const useSignout = () => {
    store.dispatch('auth/reset');
    store.dispatch('localStorage/removeLocalStorage');

    datadogRum.clearUser();
  };

  const success = ({ sessionToken, clientInfo, centerInfo, tos }: vuex.sessionHandler) => {
    store.dispatch('auth/updateSessionToken', sessionToken);
    store.dispatch('auth/updateClientInfo', clientInfo);
    store.dispatch('auth/updateCenterInfo', centerInfo);
    store.dispatch('auth/updateMarketingAgreement', tos?.marketing ?? null);
    store.dispatch('localStorage/saveToLocalStorage');

    datadogRum.setUser({
      id: clientInfo?.name ?? 'user',
      name: clientInfo?.name ?? 'user',
      version: __APP_VERSION__,
    });

    const firstOutboundURL = getMenu.value[0].children![0] ? getMenu.value[0].children![0].link : '/';

    const nextURL = sessionStorage.getItem('redirectURL');
    const redirectURL = nextURL === '/outbound/complete' ? firstOutboundURL : nextURL;

    return router.replace(redirectURL ?? '/');
  };

  const failed = () => {
    useSignout();
    return router.push('/');
  };

  return {
    success,
    failed,
    useSignout,
  };
}
